// Wrappers de Administración · Resumen (plan 2026-10-30 §2.1, T-cdqn):
// la puesta a punto que calcula core-api, los últimos cambios del
// registro de configuración y las invitaciones pendientes de auth-svc
// para la fila «Equipo invitado». Los dos de core-api exigen quien
// administra la organización (requireOrgAdmin → 403 ADMIN_REQUIRED); la
// pantalla ya está detrás de la misma capacidad en App.tsx.
//
// El registro completo (paginado, con filtro y CSV) vive en la sección
// Registro de cambios; aquí sólo se piden los tres más recientes, sin
// cursor ni sección, para el panel «Últimos cambios», por el mismo wrapper
// que usa esa sección (lib/api/endpoints/config-audit.ts).

import {
  orgInvitationListResponseSchema,
  setupStatusResponseSchema,
  type ConfigAuditListResponse,
  type OrgInvitationListResponse,
  type SetupStatusResponse,
} from "@bitacorapro/api-types";
import { request } from "../../../lib/api/client";
import { configAuditApi } from "../../../lib/api/endpoints/config-audit";

/** Cuántos cambios muestra el panel «Últimos cambios» (handoff §1). */
export const ULTIMOS_CAMBIOS_LIMIT = 3;

export const resumenApi = {
  // GET /organizations/me/setup-status — una fila por clave estable
  // (datos_logo · activos · checklists), con `ok` y el resumen en es-CL ya
  // armado con los sustantivos de la receta.
  setupStatus: async (): Promise<SetupStatusResponse> => {
    const json = await request<unknown>("GET", "core", "/organizations/me/setup-status");
    return setupStatusResponseSchema.parse(json);
  },
  // GET /organizations/me/config-audit?limit=3 — los últimos cambios de
  // cualquier sección, del más reciente al más antiguo.
  ultimosCambios: (limit = ULTIMOS_CAMBIOS_LIMIT): Promise<ConfigAuditListResponse> =>
    configAuditApi.list({ limit }),
  // GET /auth/invitations — sólo las invitaciones vivas de la organización
  // (ni aceptadas ni vencidas), sin el token. La lee cualquier miembro
  // autenticado; aquí sólo importa cuántas hay.
  invitacionesPendientes: async (): Promise<OrgInvitationListResponse> => {
    const json = await request<unknown>("GET", "auth", "/auth/invitations");
    return orgInvitationListResponseSchema.parse(json);
  },
};
